import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VesselPhoto } from '../dto/vessel-photo';

@Injectable({
  providedIn: 'root'
})
export class VesselPhotoService {

  private apiUrl = environment.apiRoot + '/vesselphoto';

  constructor(private http: HttpClient) { }

  getAllImagesOfVessel(vesselId: number): Observable<VesselPhoto[]> {
    return this.http.get<VesselPhoto[]>(this.apiUrl + '/allofvessel?vesselId=' + vesselId);
  }

  //getVesselImage(vesselId: number, imgName: string) : Observable<ArrayBuffer> {
  //  return this.http.get(this.apiUrl + '/image?vesselId=' + vesselId + '&imageName=' + imgName, {responseType: 'arraybuffer'});
  //}

  getVesselImage(photoId: number): Observable<ArrayBuffer> {
    return this.http.get(this.apiUrl + '/image?photoId=' + photoId, { responseType: 'arraybuffer' });
  }
    
  fileUpload(vesselId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    return this.http.post(this.apiUrl + '/fileupload?vesselId=' + vesselId, formData);
  }

  deleteVesselPhoto(photoId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?photoId=' + photoId);
  }
}
